module.exports = __webpack_public_path__ + "static/media/sun-is-wrong.4ca1d17d.mp3";